<!-- 打印调拨单-海口 -->
<template>
    <div v-loading="loading" style="position: relative">
        <div id="printTransContent" class="print-zone">
            <div style="width: 763px; margin: 0 auto">
                <div id="top">
                    <div class="print-title-view">
                        <div class="barfa">
                            <div class="grid-content"><svg id="barcode" /></div>
                        </div>                        
                        <div class="print-title">调拨单</div>
                        <div class="order-detail">
                            <div class="right">单号：{{ orderData.TOCode }}</div>
                            <div class="right">
                                日期：
                                <span>{{ orderData.CreateTime }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="table_b">
                    <table
                        border="1"
                        cellspacing="0"
                        cellpadding="1"
                        width="100%"
                        style="border-collapse: collapse;table-layout:fixed;border-bottom: none;"
                        bordercolor="#333333"
                    >
                        <thead>
                            <tr>
                                <td width="20%" style="border-bottom: none;">调出仓库</td>
                                <td width="30%" style="border-bottom: none;">{{ orderData.OutWarehouseName }}</td>
                                <td width="20%" style="border-bottom: none;">调入仓库</td>
                                <td width="30%" style="border-bottom: none;">{{ orderData.InWarehouseName }}</td>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div id="table">
                    <table border="1" cellspacing="0" cellpadding="1" width="100%" style="border-collapse: collapse;table-layout:fixed;" bordercolor="#333333">
                        <thead>
                            <tr>
                                <td width="6%">
                                    <div><b>序</b></div>
                                </td>
                                <td width="18%">
                                    <div><b>汽配编码</b></div>
                                </td>
                                <td width="16%">
                                    <div><b>配件名称</b></div>
                                </td>
                                <td width="10%">
                                   <div><b>配件尺寸</b></div>
                               </td>
                                <td width="17%">
                                    <div><b>车型</b></div>
                                </td>
                                 <td width="8%">
                                    <div><b>品牌</b></div>
                                </td>
                                <td width="8%">
                                    <div><b>出库数</b></div>
                                </td>
                                <td width="17%">
                                    <div><b>调出仓位</b></div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="index" v-for="(AP, index) in orderData.DetailList">
                                <td>{{ Number(index) + 1 }}</td>
                                <td>{{ AP.APCode }}</td>
                                <td>{{ AP.GoodName }}</td>
                                <td>{{ AP.Size }}</td>
                                <td style="white-space: nowrap; text-overflow: clip; overflow: hidden">{{ AP.AutoSerise }}</td>
                                <td>{{ AP.Brand }}</td>
                                <td>{{ AP.Count + ' ' + AP.Unit }}</td>
                                <td>{{ AP.GoodsLocation }}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style="text-align:right;">合计：</td>
                                <td>{{ allNum }}</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div id="foot">
                    <div class="order-remark">
                        <div style="width: 99%">备注：{{ orderData.Remark }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <div class="sort-set">
                    <el-button class="btn-primary" @click="setSortField('sortnum')">原始排序</el-button>
                    <el-button class="btn-primary" @click="setSortField('code')">编码排序</el-button>
                    <el-button class="btn-primary" @click="setSortField('shelfspace')">仓位排序</el-button>
                </div>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printTransContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        },
        printType: {
            type: Number,
            default: 0
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: userMsg.EntpName,
            imgUrl: '',
            isPreview: false,
            isDefaultSet: false,
            sortField: '',
            orderData: {},
            loading: false,
            TOCode: ''
        };
    },
    watch: {
        TOCode: {
            handler(newVal, oldVal) {
                if (newVal == oldVal || !this.isInit) return;

                this.$nextTick(function() {
                    // let canvas = this.$refs.canva;
                    // QRCode.toCanvas(
                    //     canvas,
                    //     newVal,
                    //     {
                    //         width: 80,
                    //         height: 80,
                    //         margin: 0,
                    //         scrollX: 0,
                    //         scrollY: 0
                    //     },
                    //     function(error) {}
                    // );
                    // setTimeout(() => {
                    //     html2canvas(canvas, {
                    //         width: 80,
                    //         height: 80,
                    //         scrollX: 0,
                    //         scrollY: 0
                    //     })
                    //         .then(canvasRes => {
                    //             var imgData = canvasRes.toDataURL('image/png');
                    //             this.imgUrl = imgData;
                    //             canvas.style.display = 'none';
                    //         })
                    //         .catch(error => {
                    //         });
                    // }, 1000);
                    JsBarcode('#barcode', newVal, {
                        width: 1.1,
                        height: 40,
                        fontSize: 14,
                        margin: 0,
                        displayValue: false
                    });                    
                });
            },
            immediate: true
        }
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.orderData = {};
            let sortField = this.$util.getLocalStorage('trans_print_' + this.userMsg.EmployeeId);
            if (sortField) this.sortField = sortField;
            this.getConfigByCodes().then(() => {
                this.getTransOrder();
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyyl', 'syllqdysz'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<style>
                    .print-title-view {
                        width: 762px;
                        position: relative;
                        display: flex;
                        justify-content: flex-end;
                        align-items: flex-end;
                        padding: 15px 0;
                    }
                    .barfa{display:none;}
                    .print-title {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        max-width: 50%;
                        margin: 0 auto;
                        text-align: center;
                        font-size: 20px;
                        font-weight: bold;
                        color: #000;
                        min-height: 26px;
                    }                    
                    .order-detail {
                        color: #000;
                        position: relative;
                        top: 10px;
                        right: 0px;
                    }
                    .order-code {
                        width: 80px;
                        height: 80px;
                        display: inline-block;
                        vertical-align: top;
                    }
                    .qrcode-canvas,.qrcode-image{
                        display:none;
                    }   
                    table,
                    td,
                    th {
                        border-width: 1px;
                        border-style: solid;
                        border-collapse: collapse;
                        color: #000;
                        padding-bottom: 3px;
                        padding-top: 3px;
                        padding-left: 2px;                        
                    }
                     /* 为了兼容火狐不换行 */
                    td{
                        word-break : break-all;word-wrap: break-word;
                    }                    
                    table{
                        border-top: solid 1px black;
                        border-bottom: 0px;
                        border-left: 0px;
                        border-right: 0px;    
                        font-size: 14px;                   
                    }
                    tfoot td {
                        font-weight: bold;
                        border: 0;
                    }  
                    .order-remark {
                        width: 742px;
                        display: -webkit-flex;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        margin-left: 10px;
                        margin-right: 10px;
                        padding-top: 5px;
                        color: #000;
                    }                     
                    .fwb {
                        font-weight: bold;
                        font-size:16px;
                    }
                    .btd {
                        border-bottom: 1px dashed #000;
                        font-weight: bold;
                    }
                    </style>`;

                let strPrintHtml = strBodyStyle + '<body>' + document.getElementById('printTransContent').innerHTML + '</body>';

                LODOP.ADD_PRINT_BARCODE(20, 5,  230, 40, '128Auto', this.orderData.TOCode);
                LODOP.SET_PRINT_STYLEA(0, "ShowBarText", 0);
                
                if (this.orderData.DetailList.length <= 60) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '98%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '286mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '98%', strPrintHtml);
                    LODOP.NEWPAGEA();
                }

                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.$util
                .printedRecord({
                        OrderId: this.printIds[0],
                        Type: 6
                    },true
                );
        },
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        // 获取表格数据
        getTransOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetPrintTransferOrderData',
                    data: {
                        TOId: this.printIds[0],
                        SortField: this.sortField
                    },
                    hideLoading: true
                })
                .then(res => {
                    let _allNum = 0;
                    let data = res.data;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                    }
                    this.allNum = _allNum;
                    this.orderData = {
                        CreateTime: data.CreateTime,
                        InWarehouseName: data.InWarehouseName,
                        OutWarehouseName: data.OutWarehouseName,
                        Remark: data.Remark,
                        TOCode: data.TOCode,
                        TOId: data.TOId,
                        DetailList: data.DetailList
                    };
                    this.TOCode = data.TOCode;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        setSortField(field) {
            this.$util.setLocalStorage('trans_print_' + this.userMsg.EmployeeId, field);
            this.sortField = field;
            this.getTransOrder();
        }
    }
};
</script>
<style lang="less">
.fkyou {
    border-right: 1px solid #000;
    border-left: 1px solid #000;
    border-bottom: 1px solid #000;
    margin-bottom: 0px;
}
.fkyou td {
    padding: 0;
    border-right: 1px solid #000;
    border-top: 1px solid #000;
}
.fkyou th {
    padding: 0;
    border: 1px solid #000;
}

.fkyou div {
    color: #000;
}
</style>
<style lang="less" scoped media="print">
.el-row {
    margin-bottom: 0;
}
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 12px 0;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
    .barfa {
        height: auto;
        top: 0;
        // right: -10px;
    }    
}
.order-detail {
    color: #000;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding-top: 5px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    margin-left: 2rpx;
}

.print-table-main {
    width: 792px;
    margin-left: 1px;
    font-size: 12px;
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 11px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px solid #000;
        margin: 0;
    }
    .row {
        border-top: 1px solid #000;
    }
}
.btn-ctn-left {
    display: flex;
}
.fullCut {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.fdzt {
    font-size: 14px;
}
table,
td,
th {
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    color: #000;
    padding-bottom: 3px;
    padding-top: 3px;
    padding-left: 2px;
    font-size: 14px;
}
tfoot {
    display: none;
}
</style>
